module.exports = __webpack_public_path__ + "img/shachihata-logo.7f0ac5cd.svg";